import { Component, Input } from '@angular/core';
import { StoryblokRichContent } from '../../models';
import { PageDetectionUtil } from '~shared/utils/page-detection.util';
import { NavigationHelper } from '~shared/services/navigation-helper.service';

@Component({
  selector: 'app-rich-content-wrapper',
  templateUrl: './rich-content-wrapper.component.html',
  styleUrls: ['./rich-content-wrapper.component.scss'],
})
export class RichContentWrapperComponent {
  @Input() content: StoryblokRichContent;

  currentUrl = this.navigationHelper.getCurrentUrl();

  get isContentLandingPage(): boolean {
    return PageDetectionUtil.isLandingPagePage(this.currentUrl);
  }

  constructor(
    private navigationHelper: NavigationHelper,
  ) {}
}
